"use strict";
import inView from 'in-view';

const Modules = () => {
  const init = () => {
    $(document).ready(function() {
      let banners = document.getElementsByClassName('module-banner');
      if (banners.length) {
        for(let i = 0; i < banners.length; i++) {
          bannerFunctions(banners.item(i));
        }
      }

      let sticky = document.getElementsByClassName('module-sticky');
      if (sticky.length) {
        inView.offset({
          top: 500,
          bottom: 100,
        });

        for(let i = 0; i < sticky.length; i++) {
          stickyInView(sticky.item(i));
        }
      }

      let brands = document.getElementsByClassName('module-brands');
      if (brands.length) {
        for(let i = 0; i < brands.length; i++) {
          brandsSlider(brands.item(i));
        }
      }

      let gallery = document.getElementsByClassName('module-gallery');
      if (gallery.length) {
        for(let i = 0; i < gallery.length; i++) {
          gallerySlider(gallery.item(i));
        }
      }

      let latestNews = document.getElementsByClassName('module-latest_news');
      if (latestNews.length) {
        for(let i = 0; i < latestNews.length; i++) {
          latestNewsSlider(latestNews.item(i));
        }
      }

      let history = document.getElementsByClassName('module-history');
      if (history.length) {
        for(let i = 0; i < history.length; i++) {
          historySlider(history.item(i));
        }
      }

      let team = document.getElementsByClassName('module-team');
      if (team.length) {
        for(let i = 0; i < team.length; i++) {
          teamFunctions(team.item(i));
        }
      }

      let benefits = document.getElementsByClassName('module-benefits');
      if (benefits.length) {
        for(let i = 0; i < benefits.length; i++) {
          benefitsFunctions(benefits.item(i));
        }
      }

      let awards = document.getElementsByClassName('module-awards');
      if (awards.length) {
        for(let i = 0; i < awards.length; i++) {
          awardFunctions(awards.item(i));
        }
      }

      let statistics = document.getElementsByClassName('module-statistics');
      if (statistics.length) {
        for(let i = 0; i < statistics.length; i++) {
          statisticsFunctions(statistics.item(i));
        }
      }

      let locations = document.getElementsByClassName('module-locations');
      if (locations.length) {
        for(let i = 0; i < locations.length; i++) {
          locationMaps(locations.item(i));
        }
      }
    });
  };

  const bannerFunctions = (el) => {
    let $banner = $(el);
    let $button = $banner.find('.video-button'),
      $sound = $banner.find('.sound-button'),
      video = $banner.find('video')[0];

    $button.click(function() {
      if ($button.hasClass('paused')) {
        video.play();
        $button.removeClass('paused');
      } else {
        video.pause();
        $button.addClass('paused');
      }
    });

    $sound.click(function() {
      if ($sound.hasClass('muted')) {
        video.muted = false;
        $sound.removeClass('muted');
      } else {
        video.muted = true;
        $sound.addClass('muted');
      }
    });
  };

  const stickyInView = (el) => {
    let $container = $(el);
    inView('.section').on('enter', (element) => {
      let $section = $(element),
        index = $section.data('section');

      // Set active control
      $container.find('.control').removeClass('active');
      $container.find('.control[data-control="' + index + '"]').addClass('active');

      // Set active image
      $container.find('.image').removeClass('active');
      $container.find('.image[data-image="' + index + '"]').addClass('active');
    });

    // Handle control clicks, scroll to section
    $container.find('.control').click(function() {
        let $this = $(this),
          index = $this.data('control'),
          $target = $container.find('.section[data-section="' + index + '"]'),
          navHeight = $('nav').height();

        if ($(window).width() > 768) {
          window.scrollTo({
            top: $target.offset().top - navHeight,
            behavior: "smooth",
          });
        } else {
          $container.find('.section.show').fadeOut(function() {
              $container.find('.section.show').removeClass('show');
              $target.addClass('show').fadeIn();
          });
        }
    });
  };

  const brandsSlider = (el) => {
    let $container = $(el),
      $tabs = $container.find('.tab'),
      $filter = $container.find('.filter');

    const slideOptions = {
      fade: true,
      dots: false,
      autoplay: false,
      adaptiveHeight: false,
      slidesToShow: 1,
      prevArrow: $container.find('.controls .prev'),
      nextArrow: $container.find('.controls .next'),
    };

    // Init first slider
    let $contentSlider = $container.find('.category.active .content-slider').slick(slideOptions);
    let $imageSlider = $container.find('.category.active .image-slider').slick({
      fade: true,
    });
    $contentSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $imageSlider.slick('slickGoTo', nextSlide);
    });

    const updateCategory = (index) => {
      let $activeCategory = $container.find('.category.active');
      $container.find('.tab.active').removeClass('active');
      $activeCategory.removeClass('active');
      setTimeout(() => {
        $activeCategory.addClass('hidden');
      }, 400);

      $container.find('.tab[data-category="' + index + '"]').addClass('active');

      let $category = $container.find('.category[data-category="' + index + '"]'),
        $cslider = $category.find('.content-slider'),
        $islider = $category.find('.image-slider');

      setTimeout(() => {
        $category.removeClass('hidden');
        if ($cslider.hasClass('slick-initialized')) {
          $cslider.slick('unslick');
        }
        if ($islider.hasClass('slick-initialized')) {
          $islider.slick('unslick');
        }
        $cslider.slick(slideOptions);
        $cslider.slick("setPosition", 0);

        $islider.slick({
          fade: true,
        });
        $islider.slick("setPosition", 0);

        $cslider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          $islider.slick('slickGoTo', nextSlide);
        });

        $category.addClass('active');
      }, 400);
    };

    $tabs.each(function() {
       let $tab = $(this),
         index = $tab.data('category');

       $tab.click(function() {
          updateCategory(index);
       });
    });

    $filter.on('change', 'select', function() {
      let value = $(this).val();
      updateCategory(value);
    });
  };

  const latestNewsSlider = (el) => {
    let $container = $(el);
    const slickOptions = {
      infinite: false,
      centerMode: false,
      dots: false,
      autoplay: false,
      variableWidth: true,
      slidesToScroll: 1,
      prevArrow: $container.find('.controls .prev'),
      nextArrow: $container.find('.controls .next'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            infinite: true,
          }
        }
      ]
    };

    $container.find('.slider').slick(slickOptions);
  };

  const gallerySlider = (el) => {
    let $container = $(el);
    const slickOptions = {
      dots: false,
      autoplay: false,
      variableWidth: true,
      prevArrow: $container.find('.controls .prev'),
      nextArrow: $container.find('.controls .next'),
    };

    $container.find('.slider').slick(slickOptions);
  };

  const historySlider = (el) => {
    let $container = $(el),
      $tabContainer = $container.find('.tabs'),
      $tabs = $container.find('.tab'),
      $slides = $container.find('.slide'),
      $progress = $container.find('.progress span'),
      $yearTop = $container.find('.year-top'),
      $yearBottom = $container.find('.year-bottom');
    const slickOptions = {
      infinite: false,
      dots: false,
      autoplay: false,
      variableWidth: true,
      slidesToScroll: 1,
      variableHeight: true,
      prevArrow: $container.find('.controls .prev'),
      nextArrow: $container.find('.controls .next'),
    };

    let $slider = $container.find('.slider').slick(slickOptions);

    // Progress
    const updateProgress = (index) => {
        $progress.css({width: ((index + 1) / $slides.length * 100) + '%'});
    };
    updateProgress(0);

    // On slide change
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      let year = $slides.eq(nextSlide).data('year');
      if (year) {
        $container.find('.tab.active').removeClass('active');
        $container.find('.tab[data-year="' + year + '"]').addClass('active');

        if ($yearTop.text() !== year.toString().substring(0, 2)) {
          $yearTop.fadeOut(function () {
            $yearTop.text(year.toString().substring(0, 2));
          }).fadeIn(300);
        }
        if ($yearBottom.text() !== year.toString().substring(2, 4)) {
          $yearBottom.fadeOut(function () {
            $yearBottom.text(year.toString().substring(2, 4));
          }).fadeIn(300);
        }

        if ($yearTop.text() !== year.toString().substring(0,
          2) || $yearBottom.text() !== year.toString().substring(2, 4)) {
          $tabContainer.animate({scrollLeft: $container.find('.tab.active').position().left}, 500);
        }
      }

        updateProgress(nextSlide);
    });

    // Tab click
    $tabs.each(function() {
      let $tab = $(this),
        year = $tab.data('year');

      $tab.click(function() {
        $container.find('.tab.active').removeClass('active');
        $(this).addClass('active');

        $slides.each(function(index) {
            if ($(this).data('year') === year) {
              $slider.slick('slickGoTo', index);
            }
        });
      });
    });
  };

  const awardFunctions = (el) => {
    let $container = $(el),
      $tabContainer = $container.find('.tabs'),
      $content = $container.find('.content'),
      $tabs = $container.find('.tab'),
      $prev = $container.find('.controls .prev'),
      $next = $container.find('.controls .next'),
      $yearTop = $container.find('.year-top'),
      $yearBottom = $container.find('.year-bottom');

    const updateYear = (year) => {
      // Update tab
      $container.find('.tab.active').removeClass('active');
      $container.find('.tab[data-year="' + year + '"]').addClass('active');
      $container.find('.tab.active').fadeOut(function() {
        $container.find('.tab[data-year="' + year + '"]').fadeIn();
      });

      // Update text
      if ($yearTop.text() !== year.toString().substring(0,2)) {
        $yearTop.fadeOut(function() {
          $yearTop.text(year.toString().substring(0, 2));
        }).fadeIn(500);
      }
      if ($yearBottom.text() !== year.toString().substring(2,4)) {
        $yearBottom.fadeOut(function() {
          $yearBottom.text(year.toString().substring(2,4));
        }).fadeIn(500);
      }
      if ($yearTop.text() !== year.toString().substring(0,
        2) || $yearBottom.text() !== year.toString().substring(2, 4)) {
        $tabContainer.animate({scrollLeft: $container.find('.tab.active').position().left}, 500);
      }

      // Update content
      $container.find('.content .year.active').fadeOut(function() {
        $container.find('.content .year.active').removeClass('active');
        $container.find('.content .year[data-year="' + year + '"]').hide().addClass('active').fadeIn(function() {
          // Scroll to top
          $content.animate({scrollTop: 0}, 500);
        });
      });
    };

    // Tab click
    $tabs.each(function() {
      let $tab = $(this),
        year = $tab.data('year');

      $tab.click(function() {
        updateYear(year);
      });
    });

    $prev.click(function() {
      let $activeContent = $container.find('.content .year.active'),
        index = $activeContent.data('index');
       if (index === 0) {
         updateYear($container.find('.content .year').eq($container.find('.content .year').length - 1).data('year'));
       } else {
         updateYear($container.find('.content .year').eq(index - 1).data('year'));
       }
    });

    $next.click(function() {
      let $activeContent = $container.find('.content .year.active'),
        index = $activeContent.data('index');
      if (index === $container.find('.content .year').length - 1) {
        updateYear($container.find('.content .year').eq(0).data('year'));
      } else {
        updateYear($container.find('.content .year').eq(index + 1).data('year'));
      }
    });
  };

  const teamFunctions = (el) => {
    let $container = $(el),
      $filters = $container.find('.filter'),
      $dropdownFilter = $container.find('.dropdown-filter'),
      $members = $container.find('.team-member');

    const updateTeam = (category) => {
      $('.filter.active').removeClass('active');
      $container.find('.filter[data-category="' + category + '"]').addClass('active');

      $members.removeClass('active');

      if (category == 0) {
        // All
        $members.fadeIn(400);
        $members.addClass('show');
      } else {
        $members.fadeOut(400);
        $members.removeClass('show');
        setTimeout(() => {
          $members.each(function() {
            let $member = $(this),
              categories = JSON.parse($member.data('categories'));

            if (categories.includes(category)) {
              $member.fadeIn();
              $member.addClass('show');
            }
          }, 400);
        })
      }
    };

    $filters.each(function() {
      let $this = $(this);
        $this.click(function() {
          let category = $this.data('category');
           updateTeam(category);
        });
    });

    $dropdownFilter.on('change', 'select', function() {
      let value = $(this).val();
      updateTeam(value);
    });

    $members.each(function() {
      let $member = $(this),
        $close = $member.find('.close');
      $member.find('.listing').click(function() {
        $members.removeClass('active');
        $member.addClass('active');

        let navHeight = $('nav').height();
        if ($('body').hasClass('secondary-active') && $(window).width() > 768) {
          navHeight += $('.secondary-menu').height();
        }
        window.scrollTo({
          top: $container.find('.team-members').offset().top - navHeight,
          behavior: "smooth",
        });
      });
      $close.click(function() {
        $member.removeClass('active');
      });
    });
  };

  const benefitsFunctions = (el) => {
    let $container = $(el),
      $filters = $container.find('.filter'),
      $benefitsContainer = $container.find('.benefits'),
      $benefits = $container.find('.benefit'),
      $stateFilter = $container.find('.filters .state'),
      $typeFilter = $container.find('.filters .benefit-type');

    $stateFilter.on('change', 'select', function() {
      let value = $(this).val();
      $benefits.removeClass('active');
      if (value === "all" || value === "") {
        $benefits.fadeIn(400);
        $benefits.addClass('show');
      } else {
        $benefits.fadeOut(400);
        $benefits.removeClass('show');
        setTimeout(() => {
          $benefits.each(function() {
            let $benefit = $(this),
              states = $benefit.data('state');
            if (states.includes(value)) {
              $benefit.fadeIn();
              $benefit.addClass('show');
            }
          }, 400);
        })
      }
    });

    $typeFilter.on('change', 'select', function() {
      let value = $(this).val();
      $benefits.removeClass('active');
      if (value === "all" || value === "") {
        $benefits.fadeIn(400);
        $benefits.addClass('show');
      } else {
        $benefits.fadeOut(400);
        $benefits.removeClass('show');
        setTimeout(() => {
          $benefits.each(function() {
            let $benefit = $(this);
            if (value === $benefit.data('category')) {
              $benefit.fadeIn();
              $benefit.addClass('show');
            }
          }, 400);
        })
      }
    });

    $benefits.each(function() {
      let $benefit = $(this),
        $close = $benefit.find('.close');
      $benefit.find('.listing').click(function() {
        $benefitsContainer.addClass('full-height');

        $benefits.removeClass('active');
        $benefit.addClass('active');

        let navHeight = $('nav').height();
        if ($('body').hasClass('secondary-active')) {
          navHeight += $('.secondary-menu').height();
        }
        window.scrollTo({
          top: $container.find('.benefits').offset().top - navHeight,
          behavior: "smooth",
        });
      });
      $close.click(function() {
        $benefit.removeClass('active');
        $benefitsContainer.removeClass('full-height');
      });
    });
  };

  const statisticsFunctions = (el) => {
    let $container = $(el),
      $numbers = $container.find('.number');

    // How long you want the animation to take, in ms
    const animationDuration = 2000;
    // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
    const frameDuration = 1000 / 60;
    // Use that to calculate how many frames we need to complete the animation
    const totalFrames = Math.round( animationDuration / frameDuration );
    // An ease-out function that slows the count as it progresses
    const easeOutQuad = t => t * ( 2 - t );

    const runAnimation = (el) => {
      if ($(el).hasClass('counted')) {
        return;
      }

      let frame = 0;
      const countTo = parseInt( $(el).data('number'), 10 );
      // Start the animation running 60 times per second
      const counter = setInterval( () => {
        frame++;
        // Calculate our progress as a value between 0 and 1
        // Pass that value to our easing function to get our
        // progress on a curve
        const progress = easeOutQuad( frame / totalFrames );
        // Use the progress value to calculate the current count
        const currentCount = Math.round( countTo * progress );

        // If the current count has changed, update the element
        if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
          el.innerHTML = currentCount.toLocaleString();
        }

        // If we’ve reached our last frame, stop the animation
        if ( frame === totalFrames ) {
          clearInterval( counter );
        }
      }, frameDuration );

      $(el).addClass('counted');
    };

    inView('.module-statistics .number').on('enter', (element) => {
      runAnimation(element);
    });
  };

  const locationMaps = (el) => {
    let $container = $(el),
      $map = $container.find('.map.primary'),
      $mobileMaps = $container.find('.map.mobile'),
      lat = parseFloat($map.data('lat')),
      lng = parseFloat($map.data('lng')),
      pinActive = '/themes/zimple/assets/icons/location-pin-active.svg',
      zoom = $map.data('zoom'),
      locations = $map.data('locations'),
      theme = $map.data('theme'),
      $accordion = $container.find('.accordion');

    let style = [],
      pin;
    if (theme === 'light') {
      pin = '/themes/zimple/assets/icons/location-pin-light.svg';
      style = [
        {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#444444"
            }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "color": "#f2f2f2"
            },
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "saturation": "-65"
            },
            {
              "lightness": "45"
            },
            {
              "gamma": "1.78"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "lightness": 45
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "saturation": "-33"
            },
            {
              "lightness": "22"
            },
            {
              "gamma": "2.08"
            }
          ]
        },
        {
          "featureType": "transit.station.airport",
          "elementType": "geometry",
          "stylers": [
            {
              "gamma": "2.08"
            },
            {
              "hue": "#ffa200"
            }
          ]
        },
        {
          "featureType": "transit.station.airport",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit.station.rail",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit.station.rail",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "saturation": "-55"
            },
            {
              "lightness": "-2"
            },
            {
              "gamma": "1.88"
            },
            {
              "hue": "#ffab00"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
            {
              "color": "#bbd9e5"
            },
            {
              "visibility": "simplified"
            }
          ]
        }
      ];
    } else {
      pin = '/themes/zimple/assets/icons/location-pin-dark.svg';
      pinActive = '/themes/zimple/assets/icons/location-pin-dark-active.svg'
      style = [
          {
              "featureType": "all",
              "elementType": "labels.text.fill",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          },
          {
              "featureType": "all",
              "elementType": "labels.text.stroke",
              "stylers": [
                  {
                      "visibility": "on"
                  },
                  {
                      "color": "#4A5668"
                  },
                  {
                      "weight": 2
                  },
                  {
                      "gamma": 0.84
                  }
              ]
          },
          {
              "featureType": "all",
              "elementType": "labels.icon",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "administrative",
              "elementType": "geometry",
              "stylers": [
                  {
                      "weight": 0.6
                  },
                  {
                      "color": "#243045"
                  }
              ]
          },
          {
              "featureType": "landscape",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#243045"
                  }
              ]
          },
          {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#243045"
                  }
              ]
          },
          {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#243045"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#807F7F"
                  }
              ]
          },
          {
              "featureType": "transit",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#243045"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#202222"
                  }
              ]
          }
      ];
    }

    let map = new google.maps.Map($map[0], {
      center: {lat, lng},
      zoom: parseFloat(zoom),
      disableDefaultUI: true,
      styles: style,
    });

    let markers = [];
    locations.forEach((item, index) => {
      if (item.lat && item.lng) {
        let marker = new google.maps.Marker({
          location_id: item.id,
          position: {
            "lat": parseFloat(item.lat),
            "lng": parseFloat(item.lng)
          },
          map: map,
          icon: index === 0 ? pinActive : pin,
          zIndex: 99
        });

        marker.addListener("click", () => {
          $accordion.find('.accordion-collapse[data-location="' + marker.location_id + '"]').collapse('show');
        });

        markers.push(marker);
      }
    });

    $accordion.on('show.bs.collapse', function(event) {
      let location = $(event.target).data('location');

      markers.forEach(m => {
        if (m.location_id === location) {
          map.setZoom(zoom);
          map.setCenter(m.getPosition());
          m.setIcon(pinActive);
        } else {
          m.setIcon(pin);
        }
      });
    });

    $mobileMaps.each(function() {
        let $this = $(this),
          lat = parseFloat($this.data('lat')),
          lng = parseFloat($this.data('lng'));
      let mobileMap = new google.maps.Map(this, {
        center: {lat, lng},
        zoom: parseFloat(zoom),
        disableDefaultUI: true,
        styles: style,
      });
      let latlng = new google.maps.LatLng(lat, lng);
      let marker = new google.maps.Marker({
        position: latlng,
        map: mobileMap,
        icon: pinActive,
      });
    });
  };

  return {
    init:init
  };
};

export default Modules;